import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import './TsKayitDavetLinkCard.css';

export default function TsKayitDavetLinkCard({ url, compact = false }) {
  const canvasRef = useRef(null);

  if (!url) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      window.showNotification?.('success', 'Link kopyalandı');
    } catch {
      window.showNotification?.('error', 'Kopyalanamadı');
    }
  };

  const handleDownload = () => {
    const canvas = canvasRef.current?.querySelector('canvas');
    if (!canvas) return;
    const link = document.createElement('a');
    link.download = 'servis-kayit-qr.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  const qrSize = compact ? 128 : 200;

  return (
    <div className={`ts-davet-link-card${compact ? ' compact' : ''}`}>
      <div className="ts-davet-link-row">
        <code className="ts-davet-url">{url}</code>
        <div className="ts-davet-link-actions">
          <button type="button" className="secondary-btn" onClick={handleCopy}>
            <i className="fas fa-copy" />
            <span>Kopyala</span>
          </button>
          {!compact && (
            <button type="button" className="secondary-btn" onClick={handleDownload}>
              <i className="fas fa-download" />
              <span>QR indir</span>
            </button>
          )}
        </div>
      </div>
      <div className="ts-davet-qr-wrap" ref={canvasRef}>
        <QRCodeCanvas value={url} size={qrSize} level="M" includeMargin />
      </div>
    </div>
  );
}
